<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input class="filter-item" v-model="search.name" clearable placeholder="名称" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-select class="filter-item" v-model="search.status" clearable placeholder="状态">
        <el-option v-for="kv in option.status" :key="kv.k" :label="kv.v" :value="kv.k"></el-option>
      </el-select>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-edit" @click="handleCreate">添加</el-button>
    </div>

    <el-table class="tbl" v-loading="loading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="名称" prop="name" fixed align="center" width="150px" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column label="关联量器" prop="ware_name" :show-overflow-tooltip="true">
        <template slot-scope="props">
          <span>{{ props.row.ware_name.join(', ') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" align="center" width="80px">
        <template slot-scope="props">
          <span :class="'w' + props.row.status">{{ props.row.status | statusFilter }}</span>
        </template>
      </el-table-column>
      <el-table-column label="更新时间" prop="time" width="180px" align="center"></el-table-column>
      <el-table-column label="操作" align="center" width="100" fixed="right" class-name="small-padding fixed-width">
        <template slot-scope="scope">
          <el-tooltip content="编辑" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleEdit(scope.row)">
              <svg-icon icon-class="edit"/>
            </el-button>
          </el-tooltip>
          <el-tooltip content="删除" class="item" effect="dark" placement="bottom">
            <el-button type="text" class="btn-text" @click="handleDelete(scope.row)">
              <svg-icon icon-class="delete"/>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

    <el-dialog class="dia" :title="!temp.id? '添加': '编辑'" :visible.sync="dia.edit" top="1vh">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="120px" style="max-width: 400px; margin-left:50px;">
        <el-form-item label="名称" prop="name">
          <el-input v-model="temp.name" clearable placeholder="请填写名称" />
        </el-form-item>
        <el-form-item label="文件" prop="file">
          <el-upload
            action="/api/common/upload/"
            :headers="upload.header"
            :data="upload.data"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            accept=".pdf"
            :file-list="file">
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传PDF文件，且不超过2M</div>
          </el-upload>
        </el-form-item>

        <el-form-item label="关联量器" prop="ware">
          <el-select class="filter-item" v-model="temp.ware" clearable filterable multiple collapse-tags placeholder="请选择(可搜索)" style="width: 280px;">
            <el-option-group v-for="grp in option.ware" :key="grp.name" :label="grp.name">
              <el-option v-for="kv in grp.data" :key="kv.id" :label="kv.sn" :value="kv.id"></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio v-model="temp.status" v-for="(row, idx) in option.status" :key="idx" :label="row.k">{{ row.v }}</el-radio>
        </el-form-item>
      </el-form>
       <div slot="footer" class="dialog-footer">
         <el-button @click="dia.edit = false">取消</el-button>
         <el-button type="primary" @click="saveData">确定</el-button>
       </div>
     </el-dialog>
     <!-- edit -->

  </div>
</template>

<script>
import waves from '@/directive/waves'
import { getToken } from '@/utils/auth'

const option = {
  status: [{k: 1, v: '启用'}, {k: 0, v: '停用'}],
  ware: [],
}

export default {
  name: 'Cert',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      let d = option.status.find(row => row.k == key)
      return d? d.v: '-'
    },
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      loading: false,
      search: {
        page: 1,
        size: 12,
        name: '',
        status: '',
      },
      option: option,
      upload: {
        header: { 'Authorization': 'Bearer ' + getToken() },
        data: { type: 'cert' }
      },
      file: [],
      dia: {
        edit: false
      },
      temp: {},
      rules: {
        name: [{ required: true, message: '请填写名称', trigger: 'blur' }],
        file: [{ required: true, message: '请填写上传文件', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    init() {
      const _t = this
      _t.$http.post('/api/ware/option', _t.search).then(resp => {
        _t.option.ware = resp.data
      })
    },
    getList() {
      const _t = this
      _t.loading = true
      _t.$http.post('/api/cert/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.loading = false
        }, 200)
      }).catch(() => {
        setTimeout(() => {
          _t.loading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    },
    handleCreate() {
      this.init()
      this.temp = {name: '', file: '', ware: [], status: 1}
      this.file = [];
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleEdit(row) {
      this.init()
      this.temp = Object.assign({}, row)
      this.file = [{
        name: row.file,
        url: row.fileUrl,
      }]
      this.dia.edit = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleDelete(row) {
      const _t = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const data = {
          id: row.id
        }
        _t.$http.post('/api/cert/delete', data).then(function(resp) {
          if (resp.code === 0) {
            _t.$message.success(resp.msg)
            const index = _t.list.indexOf(row)
            _t.list.splice(index, 1)
          }
        })
      })
    },
    beforeUpload(f) {
      const isPDF = f.type === 'application/pdf'
      const isLt2M = f.size / 1024 / 1024 < 2 

      if (!isPDF) {
        this.$message.error('上传文件只能是PDF格式')
      } else if (!isLt2M) {
        this.$message.error('上传文件大小不能超过2MB')
      }
      return isPDF && isLt2M
    },
    handleSuccess(resp, f) {
      if (resp.code === 0) {
        if (!this.temp.name) {
          this.temp.name = f.name
        }
        this.temp.file = resp.data.name
        this.file = [{
          name: resp.data.name,
          url: resp.data.url,
        }]
      }
    },
    handleRemove() {
      this.file = []
      this.temp.file = ''
    },
    saveData() {
      const _t = this
      _t.$refs['dataForm'].validate((valid) => {
        if (valid) {
          _t.$http.post('/api/cert/save', _t.temp).then(function(resp) {
            if (resp.code === 0) {
              _t.$message.success(resp.msg)
              _t.dia.edit = false
              _t.getList()
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.tbl {
  .w1 {
    color: #67C23A;
  }
  .w2 {
    color: #E6A23C;
  }
  .w3 {
    color: #409EFF;
  }
  .w4 {
    color: #909399;
  }
}
</style>
